import React, { Component }          from "react";
import { FontAwesomeIcon }           from '@fortawesome/react-fontawesome'
import { Button, ButtonGroup, Modal, Tabs, Tab, nav }             from "react-bootstrap";
import LoaderButton                  from "../../components/LoaderButton";
import { Colors }                    from "../../utils/Colors";
import { invokeClientExerciseHistoryDetail }  from "../../utils/AwsInvoke";
import getMeasureTitle               from "../../utils/Measure";
import uniqueId                      from 'lodash/uniqueId';
//import "../../css/modal/ModalProgramOverview.css";

export default class ModalClientExerciseDetails extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showModalClientExerciseDetails: false,
            isLoading: false,
            error_msg: "",
            exerciseName: this.props.exerciseName
        };
    }

    componentDidMount() {
        this.setState({
            showModalClientExerciseDetails: this.props.showModalClientExerciseDetails,
        });
        var client_id   = this.props.clientId;
        var exercise_id = this.props.exerciseId
        this.getModalExerciseDetailData(client_id, exercise_id);
    }

    getModalExerciseDetailData = async (client_id, exercise_id) => {
        var results = await invokeClientExerciseHistoryDetail(client_id, exercise_id)
        this.parseExerciseData(results.data);
    }

    parseExerciseData (results) {
        var exerc_data = this.parseExerciseDetailData(results);
        this.setState({
             exerciseDetailsContent: exerc_data,
        })

    }

    handleCloseWin = (action) => {
        this.setState({
            isLoading: true,
        });

        this.props.onHide();
    }


    parseExerciseDetailData (e_data) {

         var exer_arr = [];
         var old_date = "";
          for(var key_e in e_data) {
              var metric_a    = e_data[key_e].metric_a;
              var metric_b    = e_data[key_e].metric_b;
              var metric_a_id = e_data[key_e].metric_a_id;
              var metric_b_id = e_data[key_e].metric_b_id;
              var current_a_id = getMeasureTitle(metric_a_id);
              var current_b_id = getMeasureTitle(metric_b_id);
              var set_number   = e_data[key_e].set_number;
              var date_created = e_data[key_e].date_created;
              var date         = new Date(date_created).toLocaleString(('en-US'), {timeZone: 'UTC', month: 'long', day:'2-digit', hour: '2-digit'}); /*, minute:'2-digit'}); /*}, hour: '2-digit', minute:'2-digit'})} */

              if(metric_a_id === 2 && metric_b_id === 12)  current_a_id = "LBs";
              if(metric_b_id === 12) current_b_id = "Reps";

              if(current_a_id === "Pounds (Lbs)") current_a_id = "LBs";
              if(current_b_id === "Repetitions") current_b_id = "Reps";

              if(date != old_date) {
                  exer_arr.push(<div key = {uniqueId()}>
                                    <br/><b>{date}</b>
                            </div>)
              }

              exer_arr.push(<div key = {uniqueId()}
                                  className = "">
                                  <span style={{color:"#666", fontWeight:"bold", paddingRight: 20, textAlign: "left"}}>Set { set_number }. </span>
                                  { parseInt(metric_a).toFixed(0) } {current_a_id} x { parseInt(metric_b).toFixed(0) } {current_b_id}
                            </div>)
              old_date = date;
          }

          return exer_arr;
    }

    createMarkup(html) { return {__html: html}; };

    render() {
        var button_color  = "#408fd2";
        var body_text     = "Loading data...";

        var buttons = <span>
                            <Button className="modalBasicsBtnOk" onClick={() => this.handleCloseWin("ok")}>Close</Button>
                      </span>

        //var body_div  = <span className="modalAlertBody" dangerouslySetInnerHTML={this.createMarkup(body_text)} />
        var error_msg = this.state.error_msg;

        body_text = this.state.exerciseDetailsContent;

        if(error_msg != "")
            body_text = <div className="ModalProgrOverviewErrorText">{error_msg}</div>

        return (
            <div>
                  <Modal
                         show            = {this.state.showModalClientExerciseDetails}
                         onHide          = {() => this.handleCloseWin("close")}
                         aria-labelledby = "contained-modal-title"
                         size            = "lg"
                         centered        = "true"
                         className       = "modalBasics"
                       >
                         <Modal.Header>
                             <Modal.Title id="contained-modal-title">
                                    <FontAwesomeIcon icon="heartbeat" className="modalAlertIcon" />
                                    <span className="modalBasicsTitle">
                                        Exercise Details
                                    </span>
                             </Modal.Title>
                         </Modal.Header>

                         <Modal.Body>
                             <h3>{this.state.exerciseName}</h3>
                             <span className="modalAlertBody" /*dangerouslySetInnerHTML={this.createMarkup(message_body)}*/ >
                                    {body_text}
                             </span>
                         </Modal.Body>

                         <Modal.Footer>
                             {buttons}
                         </Modal.Footer>
                   </Modal>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/modal/ModalClientExerciseDetails.js